import React from 'react';
import AbstractModalView from 'common/components/AbstractModalView';
import PrivacyPolicy from './PrivacyPolicy';
import CheckboxChecked from "../../assets/checkbox_checked.svg";
import CheckboxUnchecked from "../../assets/checkbox.svg";
import styles from './styles.module.scss';

const PrivacyPolicyPopup = ({
                              label,
                              enableSubmit,
                              setEnableSubmit,
                              showCheckbox = true
                            }) => {
  const enableSubmitFunc = () => {
    setEnableSubmit(!enableSubmit)
  }

  return (
    <AbstractModalView
      subPath={'privacy-policy-and-terms-of-use'}
      modalClassName={styles.modal}
      overlayClassName={styles.overlay}
      shouldCloseOnOverlayClick={false}
      triggerContent={({openModal}) => (
        <div
          className={styles.openPopupButton}
          onClick={() => openModal()}
        >
          {label}
        </div>
      )}
      modalContent={({closeModal}) =>
        <div className={styles.privacyPolicyContainer}>
          <PrivacyPolicy />
          {showCheckbox &&
          <div
            className={styles.checkboxContainer}
            onClick={enableSubmitFunc}
          >
            {enableSubmit ?
              <img
                src={CheckboxChecked}
                alt="enabled"
                className={styles.checkboxImage}
              />
              :
              <img
                src={CheckboxUnchecked}
                alt="disabled"
                className={styles.checkboxImage}
              />
            }
            קראתי ואני מאשר את תנאי שימוש ומדיניות הפרטיות
          </div>
          }
          <div className={styles.buttonCancel} onClick={closeModal}> סגירה</div>
        </div>
      }
    >
    </AbstractModalView>
  );
};

export default PrivacyPolicyPopup;
